'use client';

import { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import AuthGuard from './AuthGuard';
import ChatModal from '../common/ChatModal';
import { useProjectStore } from '@/stores/projectStore';

interface MainLayoutProps {
  children: React.ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  const [isExpanded, setIsExpanded] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('sidebar_expanded');
      return saved !== null ? saved === 'true' : true;
    }
    return true;
  });

  const [isChatOpen, setIsChatOpen] = useState(false);
  const initProject = useProjectStore(s => s.initProject);

  useEffect(() => {
    initProject();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleToggle = () => {
    const newState = !isExpanded;
    setIsExpanded(newState);
    localStorage.setItem('sidebar_expanded', String(newState));
  };

  return (
    <AuthGuard>
      <div className="flex h-screen overflow-hidden bg-[#F4F5F7]">
        <Sidebar
          isExpanded={isExpanded}
          onToggle={handleToggle}
          onOpenChat={() => setIsChatOpen(true)}
        />
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
      <ChatModal isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </AuthGuard>
  );
}
